/**
 * HelpLayout - Layout wrapper for documentation/help pages
 * Provides sidebar navigation for help sections
 */

import { NavLink, Outlet } from 'react-router-dom';
import {
  HelpCircle,
  Rocket,
  Calendar,
  GitBranch,
  Users,
  Settings,
  Code,
} from 'lucide-react';

interface NavItem {
  name: string;
  path: string;
  icon: React.ElementType;
  description: string;
}

const navItems: NavItem[] = [
  {
    name: 'Inicio',
    path: '/help',
    icon: HelpCircle,
    description: 'Centro de ayuda',
  },
  {
    name: 'Primeros Pasos',
    path: '/help/getting-started',
    icon: Rocket,
    description: 'Guia de inicio rapido',
  },
  {
    name: 'Flujo de Citas',
    path: '/help/booking-flow',
    icon: Calendar,
    description: 'Como gestionar citas',
  },
  {
    name: 'Seguimiento de Trabajos',
    path: '/help/job-tracking',
    icon: GitBranch,
    description: 'Estados y transiciones',
  },
  {
    name: 'Portal del Cliente',
    path: '/help/customer-portal',
    icon: Users,
    description: 'Funciones para clientes',
  },
  {
    name: 'Configuracion Admin',
    path: '/help/admin-settings',
    icon: Settings,
    description: 'Ajustes del sistema',
  },
  {
    name: 'Widget de Reservas',
    path: '/help/embed-widget',
    icon: Code,
    description: 'Integracion en tu web',
  },
];

export function HelpLayout() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <HelpCircle className="h-8 w-8 text-blue-600" />
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Centro de Ayuda</h1>
          <p className="text-sm text-gray-500">
            Guias y documentacion para usar la plataforma
          </p>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row gap-6">
        {/* Sidebar Navigation */}
        <nav className="w-full lg:w-64 flex-shrink-0">
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            {navItems.map((item, index) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/help'}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                    index !== 0 ? 'border-t border-gray-100' : ''
                  } ${
                    isActive
                      ? 'bg-blue-50 text-blue-700 border-l-4 border-l-blue-600'
                      : 'text-gray-700 hover:bg-gray-50 border-l-4 border-l-transparent'
                  }`
                }
              >
                <item.icon className="h-5 w-5 flex-shrink-0" />
                <div className="min-w-0">
                  <div className="font-medium truncate">{item.name}</div>
                  <div className="text-xs text-gray-500 truncate">
                    {item.description}
                  </div>
                </div>
              </NavLink>
            ))}
          </div>
        </nav>

        {/* Content Area */}
        <div className="flex-1 min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
